import { jwtDecode } from 'jwt-decode';

// Single source of truth for Intelligence suite RBAC on the frontend.
// Mirrors backend tab ids in /app/backend/utils/intel_audit.py
export const INTEL_TABS = [
  { navId: 'home', perm: 'intel_home', label: 'Home', desc: 'Intelligence landing — revenue pulse and AI opportunities' },
  { navId: 'asset-earnings', perm: 'intel_asset_earnings', label: 'Asset Earnings', desc: 'Per-asset revenue, utilization and rev/hour' },
  { navId: 'service-sales-mix', perm: 'intel_revenue_mix', label: 'Revenue Mix', desc: 'Revenue by service, source and seasonality' },
  { navId: 'demand-calendar', perm: 'intel_demand', label: 'Demand Center', desc: 'Demand heatmaps, lead times and peak windows' },
  { navId: 'customer-insights', perm: 'intel_customer_insights', label: 'Customer Insights', desc: 'New vs returning, party sizes, top customers' },
  { navId: 'expenses', perm: 'intel_expenses', label: 'Expense Tracker', desc: 'Spend by category, asset and crew — tracked against revenue' },
  { navId: 'booking-funnel', perm: 'intel_booking_funnel', label: 'Booking Funnel', desc: 'Widget funnel — where visitors drop off' },
  { navId: 'website-analytics', perm: 'intel_website_analytics', label: 'Website Analytics', desc: 'Beacon pageviews, visitors and referrers' },
  { navId: 'audiences', perm: 'intel_audiences', label: 'Audiences', desc: 'Contact segments and audience sizes' },
  { navId: 'campaigns', perm: 'intel_campaigns', label: 'Campaigns', desc: 'Create and launch email marketing campaigns' },
];

export const getIntelAuth = () => {
  try {
    const token = localStorage.getItem('jwtToken');
    if (!token) return { isAdmin: false, perms: {}, authed: false };
    const userType = localStorage.getItem('userType');
    if (userType === 'teamMember') {
      const d = jwtDecode(token);
      const role = (d.role || '').toLowerCase();
      if (role === 'owner' || role === 'admin' || role.includes('owner')) {
        return { isAdmin: true, perms: {}, authed: true };
      }
      return { isAdmin: false, perms: d.tabPermissions || {}, authed: true };
    }
    return { isAdmin: true, perms: {}, authed: true };
  } catch {
    return { isAdmin: false, perms: {}, authed: false };
  }
};

const permOn = (perms, key) => {
  const p = perms?.[key];
  return p === true || p?.read === true;
};

export const canIntelTab = (navId) => {
  const a = getIntelAuth();
  if (a.isAdmin) return true;
  const t = INTEL_TABS.find((x) => x.navId === navId);
  return t ? permOn(a.perms, t.perm) : false;
};

export const canExportData = () => {
  const a = getIntelAuth();
  return a.isAdmin || permOn(a.perms, 'data_export');
};

export const canSeeContactDetails = () => {
  const a = getIntelAuth();
  return a.isAdmin || permOn(a.perms, 'contact_details');
};

export const hasAnyIntelAccess = () => {
  const a = getIntelAuth();
  return a.isAdmin || INTEL_TABS.some((t) => permOn(a.perms, t.perm));
};

export const intelPathFor = (navId) => (navId === 'home' ? '/intelligence' : `/intelligence/${navId}`);

export const firstIntelPath = () => {
  const t = INTEL_TABS.find((x) => canIntelTab(x.navId));
  return t ? intelPathFor(t.navId) : '/admin';
};
